import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'por-loader',
    templateUrl: './loader-component.component.html',
    styleUrls: ['./loader-component.component.scss']
})
export class LoaderComponentComponent {}
